import React from "react";
import { Input } from "@";
import MultiSearchForm from "@/shared/components/form/MultiSearchForm";
import type { CampaignsFilterValues } from "../types";
import { campaignStatusOptions } from "../types";

interface CampaignsMultiSearchProps {
  search: {
    show: boolean;
    values: CampaignsFilterValues;
  };
  updateSearch: (updates: {
    show?: boolean;
    values?: Partial<CampaignsFilterValues>;
  }) => void;
  onSubmit: () => void;
  onReset: () => void;
}

const CampaignsMultiSearch: React.FC<CampaignsMultiSearchProps> = ({
  search,
  updateSearch,
  onSubmit,
  onReset,
}) => {
  const handleInputChange = (
    field: keyof CampaignsFilterValues,
    value: unknown,
  ) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      reset={onReset}
      className="multi-search-form xl:grid-cols-6"
      style={undefined}
    >
      {/* Search term input */}
      <Input
        star
        type="text"
        label="بحث"
        value={search.values.searchTerm}
        change={(e: { target: { value: string } }) =>
          handleInputChange("searchTerm", e.target.value)
        }
      />

      {/* Status dropdown */}
      <Input
        star
        type="select"
        label="الحالة"
        list={campaignStatusOptions}
        value={search.values.status}
        change={(e: { target: { value: string } }) =>
          handleInputChange("status", e.target.value)
        }
      />

      {/* Has finished dropdown */}
      {/*<Input*/}
      {/*  star*/}
      {/*  type="select"*/}
      {/*  label="اكتمال الحملة"*/}
      {/*  list={hasFinishedOptions}*/}
      {/*  value={search.values.hasFinished}*/}
      {/*  change={(e: { target: { value: string } }) =>*/}
      {/*    handleInputChange("hasFinished", e.target.value)*/}
      {/*  }*/}
      {/*/>*/}

      {/* Date range picker */}
      <Input
        star
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="xl:col-span-2"
        valueA={search.values.createdFrom}
        valueB={search.values.createdTo}
        changeA={(date: Date | null) => handleInputChange("createdFrom", date)}
        changeB={(date: Date | null) => handleInputChange("createdTo", date)}
      />
    </MultiSearchForm>
  );
};

export default CampaignsMultiSearch;
